"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const conversionUtils_1 = require("../../conversionUtils");
const uiNodes_1 = require("../../uiNodes");
const types_1 = require("./types");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uiNodes_1.tapeNodes.file_generatedBorrowingBaseReport.isIntermediateRecord(tape), `intermediateToUINodes: tape is not an ${types_1.artifactType}`);
    const { id, artifactSlug } = tape;
    const { tapeDescription, operationDescription: _unused, createServicerReport, } = tape.configuration;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            description: tapeDescription,
            createServicerReport: !!createServicerReport,
        },
    };
    return {
        operationNode: null,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, graph, node } = params;
    (0, common_1.finleyAssert)(uiNodes_1.tapeNodes.file_generatedBorrowingBaseReport.isNode(node), `uiNodesToIntermediate: node is not a generatedBorrowingBaseReport node: ${node.metadata.tapeBuilderNodeType}`);
    const { artifactSlug, description: tapeDescription, createServicerReport, } = node.configuration;
    // Begin check for funding submission intermediate node
    let fundingSubmissionArtifactSlug;
    const { srcTapes } = (0, conversionUtils_1.getOperationAndTapes)({
        node,
        graph,
    });
    // Find connected intermediate tape nodes
    const intermediateTapeNodes = srcTapes.filter(({ metadata }) => metadata.tapeBuilderNodeType === uiNodes_1.tapeNodes.file_intermediateTape.nodeType);
    // Validate only 1 intermediate tape can be connected at this time
    (0, common_1.finleyAssert)(intermediateTapeNodes.length <= 1, 'uiNodesToIntermediate: only 1 intermediate node can be connected to provide intended funding submission amounts and target dates');
    // Optional node, no assertion required
    const fundingSubmissionNode = intermediateTapeNodes[0];
    if (fundingSubmissionNode) {
        fundingSubmissionArtifactSlug =
            fundingSubmissionNode.configuration.artifactSlug;
    }
    // End check for funding submission intermediate node
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug: null,
        loanProductSlug: null,
        externalFilename: null,
        configuration: {
            tapeDescription,
            createServicerReport,
            fundingSubmissionArtifactSlug,
        },
    };
    return {
        record,
        operationNode: null,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map